// import { AiFillAppstore } from "react-icons/ai";
import { FaGlobe} from "react-icons/fa";
import { SiProgress, SiAntdesign } from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <FaGlobe />,
    title: "Web Development",
    des: "I create a nice and appealing website that makes your customer have a sense of satisfaction.",
  },
  {
    id: 2,
    icon: <SiProgress />,
    title: "Product Management",
    des: "As a certified product manager I effectiuvely manage software products and work smartly with my teams.",
  },
  {
    id: 3,
    icon: <SiAntdesign />,
    title: "UI/UX Design",
    des: "I am very good with design tools such as Figma, Photoshop and Canva to bring your ideas to great designs.",
  },
  // {
  //   id: 4,
  //   icon: <FaMobile />,
  //   title: "Mobile Development",
  //   des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque solutahic consequuntur eum repellendus ad",
  // },
  // {
  //   id: 5,
  //   icon: <SiAntdesign />,
  //   title: "UX Design",
  //   des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque solutahic consequuntur eum repellendus ad",
  // },
  // {
  //   id: 6,
  //   icon: <FaGlobe />,
  //   title: "Hosting Websites",
  //   des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque solutahic consequuntur eum repellendus ad",
  // },
];
